import {Component} from '@angular/core';
import {InformationModalService} from "./information-modal.service";

@Component({
    selector: 'information-modal',
    providers: [],
    templateUrl: './information-modal.component.html'
})
export class InformationModalComponent {

    constructor(private informationModalService: InformationModalService){

    }

    getInformationModal(){
        return this.informationModalService;
    };
}


// WEBPACK FOOTER //
// ./public/upgrade/root/information-modal/information-modal.component.ts